import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrS3FileDisplay from 'client/components/SrS3FileDisplay';
import SrModalV2, {
  MODAL_THEME_FIXED_FOOTER_BUTTON_PREVIEW_DOCS,
} from 'client/components/SrModalV2/SrModalV2';
import { SR_BUTTON_THEME_ADOBE_BLUE } from 'client/components/SrButton/SrButton';

const SrPreviewAndDownloadDocsModal = ({ onClose, onDownload, documents }) => {
  return (
    <SrModalV2
      centerContent
      closeOnBackgroundClick
      contentMaxWidth="1030px"
      theme={MODAL_THEME_FIXED_FOOTER_BUTTON_PREVIEW_DOCS}
      onClose={onClose}
      buttonTheme={SR_BUTTON_THEME_ADOBE_BLUE}
      contentPadding="28px 10px 0"
      padding="2vh 0 0"
      margin="0 auto"
      buttonProps={[
        {
          text: 'Download Marketing Docs',
          theme: SR_BUTTON_THEME_ADOBE_BLUE,
          onClick: onDownload,
          minWidth: '100%',
        },
      ]}
    >
      <SrBox width="100%" height="calc(100% - 55px)" overflowY="auto">
        {documents.map((documentUrl) => (
          <SrS3FileDisplay url={documentUrl} maxWidth="100%" maxHeight="800px" />
        ))}
      </SrBox>
    </SrModalV2>
  );
};

SrPreviewAndDownloadDocsModal.propTypes = {
  documents: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
};

SrPreviewAndDownloadDocsModal.displayName = 'SrPreviewAndDownloadDocsModal';

export default SrPreviewAndDownloadDocsModal;
